module.exports = __webpack_public_path__ + "static/img/head.ad5d1515.png";